import { InputAdornment, makeStyles, PropTypes, TextField, Theme, Tooltip } from "@material-ui/core";
import { createStyles } from '@material-ui/styles';
import { FontWeightProperty } from "csstype";
import React from "react";
import NumberFormat from 'react-number-format';
import { numberFieldWidth } from "../style/GlobalStyles";
import clsx from 'clsx';
import { useState } from "reactn";

export type NumberFieldProps = {
  id?: string,
  name?: string,
  label?: string,
  helperText?: string,
  value: any,
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  onBlur?: any,
  className: string,
  style?: React.CSSProperties,
  readOnly?: boolean,
  min?: number,
  max?: number,
  symbol?: string,
  forcedError?: boolean,
  forcedErrorMessage?: string,
  step?: number,
  tooltip?: string,
  special?: boolean,
  disabled?: boolean,
  hide?: boolean,
  margin?: PropTypes.Margin,
  denyFormat?: boolean,
  // inputProps?: InputBaseComponentProps
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "9rem",
      '&:hover': {
        whiteSpace: "initial",
        width: "11rem",
      },
    },
    inputPadding: {
      paddingBottom: '3px!important',
      // background: '#0defff' necessary to see if it is Aligned
    }
  })
);

// interface NumberFormatCustomProps {
//   inputRef: (instance: NumberFormat | null) => void;
//   onChange: (event: { target: { value: string } }) => void;
// }

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;
  console.log('Number format');
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      // thousandSeparator
      thousandSeparator={"."}
      decimalSeparator={","}
      isNumericString
    />
  );
}

function NumberFormatCustomNoThousandSep(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value
          }
        });
      }}
      // thousandSeparator
      // thousandSeparator={"."}
      // decimalSeparator={","}
      isNumericString
    />
  );
}

export function NumberField(props: NumberFieldProps) {
  let classes = useStyles();
  let readonly = props.readOnly != null && props.readOnly !== false && props ? true : false;
  let changeFn = props.onChange!;

  let error = props.forcedError || (!readonly && (props.value < (props.min || 0) || props.value > (props.max || 9999999)));
  let label = props.label;
  let hideT = props.hide ? 1 : 0;
  let specialT = props.special ? 1 : 0;
  // let inputProps = tabIndex ? {'tabIndex:' tabIndex}

  // function NumberFormatCustom(props: NumberFormatCustomProps) {
  //   const { inputRef, onChange, ...other } = props;

  //   return (
  //     <NumberFormat
  //       {...other}
  //       getInputRef={inputRef}
  //       thousandSeparator
  //       isNumericString
  //       onValueChange={values => {
  //         onChange({
  //           target: {
  //             value: values.value,
  //           },
  //         });
  //       }}
  //     />
  //   );
  // }

  //const classesX = useStyles();
  if (props.tooltip !== undefined) {
    label = label + " *";
  }
  let _fontWeight: FontWeightProperty = specialT !== undefined && specialT ? "bold" : "normal";
  let inputP: any = { max: props.max || 9999999, min: props.min || 0 };
  if (readonly) {
    inputP = { max: props.max || 9999999, min: props.min || 0, tabIndex: -1 };
  }
  let styleP: any = { ...props.style, maxWidth: numberFieldWidth, fontWeight: _fontWeight };
  const myClass = clsx(props.className);
  return (
    <React.Fragment>
      {hideT ? <p></p> :
        <Tooltip title={props.tooltip !== undefined ? props.tooltip! : ""}>
          <TextField
            disabled={props.disabled !== undefined && props.disabled!}
            onBlur={props.onBlur}
            onFocus={event => {
              event.target.select()
            }}
            defaultValue={0}
            placeholder={props.label}
            {...props}
            id={props.id !== undefined ? props.id : props.name}
            name={props.name}
            type="text"
            label={label}
            value={props.value ? Number(props.value) : props.value}
            onChange={changeFn}
            className={myClass}
            style={styleP}
            InputProps={{
              readOnly: readonly,
              disableUnderline: true,
              inputProps: inputP,
              inputComponent: props.denyFormat ? NumberFormatCustomNoThousandSep : NumberFormatCustom,
              // inputComponent: NumberFormatCustom as any,
              startAdornment: <InputAdornment position="start" variant="outlined">{props.symbol !== null && props.symbol !== undefined ? props.symbol : "€"}</InputAdornment>,
              classes: {input: classes.inputPadding}
            }}
            error={error}
            InputLabelProps={{
              shrink: true,
              classes: { root: classes.formControl },
              style: { fontWeight: _fontWeight }
            }}
            margin={props.margin ? props.margin : "dense"}
            helperText={props.forcedError ? props.forcedErrorMessage : (error ? "Valore non valido" : props.helperText)} />
        </Tooltip>
      }
    </React.Fragment>
  )
}